import { BookOpen, Library, GraduationCap, FlaskConical, Sparkles, Compass } from "lucide-react";
import { Section, SectionTitle, Reveal } from "@/components/Section";
import { useContent } from "@/i18n";
import { Shape3D } from "@/components/Objects3D";

const icons = { BookOpen, Library, GraduationCap, FlaskConical, Sparkles, Compass };

export const Exploring = () => {
  const { c, ui } = useContent();
  return (
    <Section id="exploring" num="01" chapter={ui.exploring.chapter} blue>
      <Shape3D shape="cloud" size={70} className="absolute right-[8%] top-16 opacity-80 hidden md:block" />
      <div className="flex flex-wrap items-end justify-between gap-6 relative">
        <SectionTitle className="max-w-2xl">
          {ui.exploring.titleA} <span className="italic text-cobalt">{ui.exploring.titleB}</span>
        </SectionTitle>
        <Reveal delay={0.15}>
          <p className="text-xs tracking-[0.25em] uppercase text-choco font-bold bg-cream border border-line rounded-full px-4 py-2 -rotate-2" data-testid="exploring-stamp">
            {ui.exploring.stamp}
          </p>
        </Reveal>
      </div>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {c.exploring.map((item, i) => {
          const Icon = icons[item.icon];
          const rotations = ["-rotate-1", "rotate-1", "-rotate-2", "rotate-2", "rotate-1", "-rotate-1"];
          return (
            <Reveal key={item.label} delay={0.06 * i}>
              <article
                className={`group relative h-full rounded-2xl border border-line bg-cream p-8 md:p-9 shadow-[0_18px_40px_-24px_rgba(51,38,25,0.25)] hover:shadow-[0_24px_50px_-24px_rgba(51,38,25,0.35)] hover:-translate-y-1.5 transition-[transform,box-shadow] duration-500 ${rotations[i % rotations.length]}`}
                data-testid={`exploring-card-${i}`}
              >
                <div className="flex items-center justify-between">
                  <span className={`flex h-11 w-11 items-center justify-center rounded-full ${i % 2 === 0 ? "bg-powder" : "bg-beige"}`}>
                    <Icon size={19} strokeWidth={1.8} className={i % 2 === 0 ? "text-cobalt" : "text-choco"} />
                  </span>
                  <span className="text-[10px] tracking-[0.25em] uppercase text-cocoa font-bold">{item.label}</span>
                </div>
                <h3 className="mt-7 font-serif text-2xl md:text-[1.7rem] tracking-tight leading-snug group-hover:text-cobalt transition-colors duration-400">
                  {item.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-cocoa">{item.text}</p>
              </article>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
};
